export default "__VITE_ASSET__17bf63b3__"